export interface CategoryLink {
  name: string;
  url: string;
}

export const categoryLinks: CategoryLink[] = [
  { name: "Shoes", url: "https://kaspreadsheet.com/category-911-Shoes.html" },
  { name: "Hoodies & Sweaters", url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html" },
  { name: "T-Shirts", url: "https://kaspreadsheet.com/category-913-T-Shirts.html" },
  { name: "Jackets", url: "https://kaspreadsheet.com/category-914-Jackets.html" },
  { name: "Pants & Shorts", url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html" },
  { name: "Headwear", url: "https://kaspreadsheet.com/category-916-Headwear.html" },
  { name: "Sets", url: "https://kaspreadsheet.com/category-917-Sets.html" },
  { name: "Underwear", url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html" },
  { name: "Jersey", url: "https://kaspreadsheet.com/category-919-Jersey.html" },
  { name: "Accessories", url: "https://kaspreadsheet.com/category-920-Accessories.html" },
  { name: "Bags", url: "https://kaspreadsheet.com/category-921-Bags.html" },
  { name: "Belts", url: "https://kaspreadsheet.com/search-922/name/Bags.html" },
  { name: "Perfumes", url: "https://kaspreadsheet.com/search-923/name/Bags.html" },
  { name: "Other Stuff", url: "https://kaspreadsheet.com/search-924/name/Bags.html" },
];

export const testimonialData = [
  {
    name: "Marcus J.",
    role: "Sneaker Collector",
    avatar: "MJ",
    rating: 5,
    title: "Best spreadsheet ever",
    content: "The superbuy spreadsheet completely changed how I find quality items. Every link is verified and the category organization makes browsing effortless. I've saved hundreds using these curated links.",
  },
  {
    name: "Emily R.",
    role: "Fashion Blogger",
    avatar: "ER",
    rating: 5,
    title: "A game changer for shopping",
    content: "As someone who reviews fashion daily, having a trusted superbuy spreadsheet link directory is invaluable. The QC tips and verified seller links give me confidence in every purchase.",
  },
  {
    name: "David K.",
    role: "Streetwear Enthusiast",
    avatar: "DK",
    rating: 5,
    title: "My go-to resource",
    content: "I check the superbuy spreadsheet updates every week. The fresh links and new category additions keep me ahead of trends. This is the only link directory I trust for superbuy shopping.",
  },
  {
    name: "Sarah M.",
    role: "Reseller",
    avatar: "SM",
    rating: 5,
    title: "Essential for resellers",
    content: "The superbuy spreadsheet is essential for my reselling business. The organized category links help me source inventory efficiently, and the QC guides ensure I only buy quality products.",
  },
  {
    name: "Alex T.",
    role: "Sneakerhead",
    avatar: "AT",
    rating: 5,
    title: "Incredibly well organized",
    content: "Finally a superbuy spreadsheet that's actually updated regularly. The category navigation is intuitive, and every link I've tried leads to exactly what's described. Highly recommend this resource.",
  },
  {
    name: "Jordan L.",
    role: "Online Shopper",
    avatar: "JL",
    rating: 5,
    title: "Saves me so much time",
    content: "Before finding this superbuy spreadsheet link directory, I spent hours searching for reliable links. Now everything is organized in one place with clear categories. Total time saver.",
  },
];